// Безопасная функция для парсинга JSON
export const safeJsonParse = (jsonString, defaultValue = null) => {
  if (!jsonString || typeof jsonString !== 'string') {
    return defaultValue;
  }

  try {
    const trimmed = jsonString.trim();
    if (trimmed === '' || trimmed === 'null' || trimmed === 'undefined' || trimmed === 'none') {
      return defaultValue;
    }

    return JSON.parse(trimmed);
  } catch (error) {
    // console.warn('JSON parse error:', error, 'Input:', jsonString);
    return defaultValue;
  }
};

export default safeJsonParse;
